import { api } from './cliente.js';

export type TipoItemMeuTrabalho = 'atividade' | 'gate' | 'demanda' | 'raid' | 'beneficio';

export interface ItemMeuTrabalho {
  tipo: TipoItemMeuTrabalho;
  id: string;
  titulo: string;
  prazo: string | null;
  contextoId: string;
}

export function buscarMeuTrabalho(): Promise<ItemMeuTrabalho[]> {
  return api.get<ItemMeuTrabalho[]>('/meu-trabalho');
}
